import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getAuthState } from '../../common/redux/selectors/authInfoSelector';
import TopNavigationMenu from './TopNavigationMenu';
import { getAssetType } from '../../common/asset-types/redux/selectors/AssetTypesSelectors';

const mapStateToProps = (state) => ({
  auth: getAuthState(state),
  assetType: getAssetType(state),
});

const AppHeaderCenterAuthenticatedContainer = () => (
  <div className="header-center-container">
    <TopNavigationMenu />
  </div>
);

const AppHeaderCenterNotAuthenticatedContainer = () => (
  <div className="header-center-container" />
);

export class AppHeaderCenterContainer extends React.Component {
  render() {
    const { auth } = this.props;
    return (
      (auth.isAuthenticated() && this.props.assetType.appContext != null) ? <AppHeaderCenterAuthenticatedContainer />
        : <AppHeaderCenterNotAuthenticatedContainer />
    );
  }
}

AppHeaderCenterContainer.propTypes = {
  auth: PropTypes.objectOf(PropTypes.shape),
  assetType: PropTypes.objectOf(PropTypes.shape),
};

export default connect(mapStateToProps)(AppHeaderCenterContainer);

export {
  AppHeaderCenterNotAuthenticatedContainer,
  AppHeaderCenterAuthenticatedContainer,
};
